import "./slotsDetailTable.scss";
import { SlotsDetailTableProps } from "./types";
import { formatDDMMYYYY, formatHHMM } from "utils/date";
import { SlotsConstants } from "constants/slots";
import "./i18n";
import { useTranslation } from "react-i18next";
import { HeaderType, Table } from "@pickit/pickit-components";
import { SlotsType } from "sagas/types/slots";
import useTableConfig from "hooks/useTableConfig";

const SlotsDetailTable = ({
  slots,
  seeMore,
  isAllSelected,
  enableCheck,
  testId,
  collapse,
  openModal,
  seeMoreSlots,
  toggleAll,
  toggleItem,
  isSelected,
}: SlotsDetailTableProps) => {
  const { t } = useTranslation("tableSlots");
  const { fontSize, rowCount } = useTableConfig(collapse);
  const headers: HeaderType<SlotsType>[] = [
    {
      key: "region.name",
      label: t("region"),
      testId: "region",
    },
    {
      key: "workZone.name",
      label: t("workzone"),
      testId: "workzone",
    },
    {
      key: ["taken", "capacity"],
      label: t("capacity"),
      testId: "capacity",
      textConfig: {
        separator: "/",
        formatter: [(data: string) => `${data || 0}`, (data: string) => data],
      },
    },
    {
      key: ["startAt", "finishAt"],
      label: t("shift"),
      testId: "time",
      textConfig: {
        formatter: [
          (date: string) => {
            return `${formatHHMM(date)} - `;
          },
          (date: string) => {
            return `${formatHHMM(date)}`;
          },
        ],
      },
    },
    {
      key: "startAt",
      label: t("date"),
      testId: "date",
      textConfig: {
        formatter: (startAt: string) => formatDDMMYYYY(startAt),
      },
    },
    {
      type: "checkbox",
      testId: "select",
      col: 1,
      align: "center",
      showCondition: (slot: SlotsType) =>
        SlotsConstants.isCancellableSlot(slot.status?.tag),
      checkboxConfig: {
        isChecked: (slot: SlotsType) => isSelected(slot.id),
        onChangeCheck: (slot: SlotsType) => toggleItem && toggleItem(slot),
        selectAll: () => toggleAll && toggleAll(),
        allSelected: () => isAllSelected,
        isDisabled: () => !enableCheck,
      },
    },
  ];

  return (
    <Table<SlotsType>
      data={slots}
      headers={headers}
      rowCount={rowCount}
      size="small"
      testId={`${testId}-table`}
      pagination="view-more-button"
      loadMoreRows={seeMoreSlots}
      hasMoreRows={seeMore}
      fontSize={fontSize}
      onClickRow={(row) => openModal(true, row.id)}
      cols={16}
    />
  );
};

export default SlotsDetailTable;
